import { render } from "./SeparationFNF.vue?vue&type=template&id=6e9f5885&scoped=true"
import script from "./SeparationFNF.vue?vue&type=script&lang=js"
export * from "./SeparationFNF.vue?vue&type=script&lang=js"

import "@/assets/css/hr-page-shared.css?vue&type=style&index=0&lang=css&external"
import "./SeparationFNF.vue?vue&type=style&index=1&id=6e9f5885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9f5885"]])

export default __exports__